import ruleBuilder from '../utils/RuleBuilder';

export default {
  ...ruleBuilder('operands')
};
